<div class="documents-section" [class.readonly-mode]="readonlyMode">
  <h3 class="section-title" *ngIf="!readonlyMode">Gestion des documents</h3>
  @if (isProjectLocked && !readonlyMode) {
  <div class="alert alert-warning mb-4">
    Le projet est verrouillé (VALIDE/TERMINE): l'ajout et la suppression de documents sont désactivés.
  </div>
  }
  @if (localErrorMessage() && !readonlyMode) {
  <div class="alert alert-error mb-4">{{ localErrorMessage() }}</div>
  }
  @if (successMessage() && !readonlyMode) {
  <div class="alert alert-success mb-4">{{ successMessage() }}</div>
  }

  <div class="doc-list" [class.compact]="readonlyMode">
    @for (ref of referentials(); track ref.id) {
    @if (shouldDisplayReferential(ref)) {
    <div class="doc-item card mb-6" [class.readonly-item]="readonlyMode"
      [class.drag-over]="draggedOverReferentialId() === ref.id" (dragover)="onDragOver($event, ref.id!)"
      (dragleave)="onDragLeave($event)" (drop)="onDrop($event, ref.id!)">
      <div class="doc-item-header" *ngIf="!readonlyMode">
        <div class="doc-type-info">
          <span class="doc-type-name">
            {{ ref.name }}
            <span class="mandatory-star" *ngIf="ref.mandatory" title="Ce document est obligatoire">*</span>
          </span>
          <span class="doc-limit" *ngIf="ref.maxDocs">Limite: {{ ref.maxDocs }} doc(s)</span>
          @if (ref.mandatory) {
          <span class="mandatory-label">Obligatoire</span>
          }
          @if (ref.archived) {
          <span class="doc-archived">Type archivé</span>
          }
        </div>

        <div class="doc-actions">
          <input type="file" #fileInput class="file-input" (change)="onFileSelected($event, ref.id!)"
            [disabled]="isUploading() === ref.id">
          <button class="btn btn-sm btn-outline btn-with-icon" (click)="openFileDialog(fileInput, ref.id!)"
            [disabled]="isProjectLocked || ref.archived || isUploading() === ref.id || (ref.maxDocs && getDocsByReferential(ref.id!).length >= ref.maxDocs)">
            <mat-icon aria-hidden="true">upload</mat-icon>
            {{ isUploading() === ref.id ? 'Upload en cours...' : (ref.archived ? 'Archivé' : 'Importer') }}
          </button>
        </div>
      </div>

      <mat-progress-bar mode="indeterminate" *ngIf="isUploading() === ref.id" class="upload-progress"></mat-progress-bar>

      <div class="doc-item-body">
        @for (doc of getDocsByReferential(ref.id!); track doc.id) {
        <div class="uploaded-doc-container" [class.readonly-doc]="readonlyMode">
          <div class="uploaded-doc">
            <div class="doc-info">
              <mat-icon class="doc-icon" aria-hidden="true">description</mat-icon>
              <div class="doc-text-info">
                <span class="doc-type-badge" *ngIf="readonlyMode">{{ ref.name }}</span>
                <span class="doc-filename" [title]="doc.fileName">{{ doc.fileName }}</span>
                <span class="doc-size">({{ (doc.size / 1024).toFixed(1) }} KB)</span>
              </div>
            </div>
            <div class="doc-buttons">
              <button class="btn-icon" (click)="onDownloadDoc(doc)" title="Télécharger" *ngIf="!readonlyMode">
                <mat-icon aria-hidden="true">download</mat-icon>
              </button>
              <button [class]="readonlyMode ? 'btn btn-outline btn-sm btn-with-icon' : 'btn-icon'"
                (click)="onPreviewDoc(doc)" title="Visualiser">
                <mat-icon aria-hidden="true">visibility</mat-icon>
                <span *ngIf="readonlyMode">Visualiser</span>
              </button>
              <button class="btn-icon delete" (click)="onDeleteDoc(doc.id!)" [disabled]="isProjectLocked"
                title="Désuploader" *ngIf="!readonlyMode">
                <mat-icon aria-hidden="true">delete</mat-icon>
              </button>
            </div>
          </div>
          <div class="doc-comment-section">
            <div class="reference-field mb-2">
              <div class="field-header" *ngIf="ref.docReferenceMandatory && !doc.docReference">
                <mat-icon class="warning-icon">priority_high</mat-icon>
                <span class="warning-text">Référence requise (N° plan/Indice)</span>
              </div>
              <label class="field-label-compact" *ngIf="!ref.docReferenceMandatory || doc.docReference">N° de plan /
                Indice du tableau :</label>
              <input type="text" class="form-control compact-input" [ngModel]="doc.docReference"
                (ngModelChange)="onDocReferenceChange(doc, $event)" placeholder="ex: PLAN-001 Rev A"
                [disabled]="isProjectLocked || readonlyMode"
                [class.field-missing]="ref.docReferenceMandatory && !doc.docReference">
            </div>
            <div class="comment-header" *ngIf="ref.commentMandatory && !doc.comment">
              <mat-icon class="warning-icon">priority_high</mat-icon>
              <span>Commentaire requis</span>
            </div>
            <textarea class="doc-comment-input" [ngModel]="doc.comment" (ngModelChange)="onCommentChange(doc, $event)"
              [placeholder]="ref.commentPlaceholder || 'Ajouter un commentaire...'"
              [disabled]="isProjectLocked || readonlyMode"
              [class.comment-missing]="ref.commentMandatory && !doc.comment" rows="1">
            </textarea>
          </div>
        </div>
        } @empty {
        <div class="no-doc" *ngIf="!readonlyMode">Aucun document importé</div>
        }
      </div>
    </div>
    }
    } @empty {
    <div class="empty-state" *ngIf="!readonlyMode">
      <mat-icon class="empty-icon" aria-hidden="true">settings</mat-icon>
      <p>Aucun type de document configuré dans le référentiel.</p>
    </div>
    }
  </div>
</div>

@if (previewDoc()) {
<app-project-doc-preview-dialog [doc]="previewDoc()!" [onClose]="closePreview.bind(this)">
</app-project-doc-preview-dialog>
}

@if (deleteConfirmDocId()) {
<app-confirmation-dialog dialogTitle="Supprimer le document"
  message="Voulez-vous vraiment supprimer ce document ? Cette action est irréversible." confirmLabel="Supprimer"
  cancelLabel="Annuler" [isDanger]="true" (confirm)="confirmDelete()" (cancel)="cancelDelete()">
</app-confirmation-dialog>
}
